import React from "react";

import { Add } from "@mui/icons-material";
import { Button, ButtonProps } from "@mui/material";

const AddButton: React.FC<ButtonProps> = (props) => {
  return (
    <Button {...props} startIcon={<Add />} variant="text">
      Lägg till
    </Button>
  );
};

export default AddButton;
